export const HOME = '/';
export const CALL = '/call';